import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Platform, ToastController, AlertController ,LoadingController,Loading  } from 'ionic-angular';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

import { Http } from '@angular/http';
import { SharedComponent } from '../shared/shared';
import { Network } from '@ionic-native/network';
import { Device } from '@ionic-native/device';
import { InAppPurchase } from '@ionic-native/in-app-purchase';
import { TranslateService } from '@ngx-translate/core';



@Injectable()
export class CommonService {
  currentUser: {};
  loading: Loading;
  baseUrl = this.sharedClass.baseUrl;
  headers =  this.sharedClass.header;
  allLanguage=[{"language":"English","languageId":"en"},
  // {"language":"Română","languageId":"ro"},
  {"language":"हिंदी",languageId:"hi"},
  {"language":"中文",languageId:"zh"},
  {"language":"Español",languageId:"es"},
  {"language":"العربية",languageId:"ar"},    
  {"language":"Русский",languageId:"ru"},
  {"language":"Bahasa melayu",languageId:"ms"},
  {"language":"français",languageId:"fr"}
  ]
  selectedItem="en";
  

  constructor(private http: Http, public sharedClass:SharedComponent, public alertCtrl:AlertController,private loadingCtrl: LoadingController,private network: Network,private device: Device,private platform:Platform,public toastCtrl: ToastController,private iap: InAppPurchase,public translate: TranslateService){

    if(localStorage.getItem('selected-lang') && localStorage.getItem('selected-lang')!=null){
      this.selectedItem=localStorage.getItem('selected-lang');
    }
  }

  
  public getCategories() {

    //return Observable.create(observer => {

      return this.http.get(this.baseUrl+'/company/categories',{headers:this.headers})
      .map(response => response.json())
      /*.do(data => {
        console.log(data);
        //observer.next(data);
        //observer.complete();
      })*//*, error => {
        console.log(error);// Error getting the data
        observer.next(false);
        observer.complete();
      });*/

      // });

    }

    callApi(data,url){
       if(localStorage.getItem('deviceToken') && localStorage.getItem('deviceToken')!="null"){
        data.deviceToken=localStorage.getItem('deviceToken');
      }

      return Observable.create(observer => {       

        this.http.post(this.baseUrl+url,data,{headers:this.headers})
        .map(response => response.json())
        .subscribe(data => {

          observer.next(data);
          observer.complete();
        }, error => {
          console.log(error);// Error getting the data
          observer.next(false);
          observer.complete();
        });;

      });
    }


    public getFactors(params) {

      if(!params.companyId && this.getLoggedInUserData()) 
        {
          params.companyId = this.getLoggedInUserData().companyId;
        }
       return this.callApi(params,"company/factors/");
    }

     public getMySubscription(subscribedPlan = this.getLoggedInUserData().company.subscribedPlan) {
      let requestData={subscription_id:subscribedPlan};     
      return this.callApi(requestData,"razorpaypayments/getSubcription/");
    }

    public cancelMySubscription(subscribedPlan = this.getLoggedInUserData().company.subscribedPlan) {
      let requestData={subscription_id:subscribedPlan, cancel_at_cycle_end : 1};     
      return this.callApi(requestData,"razorpaypayments/cancelSubcription/");
    }

    

    public getCompanyRatingCollectors() {
      let companyId = this.getLoggedInUserData().companyId
      let requestData={companyId:companyId};
      return this.callApi(requestData,"user/ratingCollectors/");  

    }

    public getCompanyCustomers() {
      let companyId = this.getLoggedInUserData().companyId
      let requestData={companyId:companyId};
      return this.callApi(requestData,"company/customers/");    

    }

    public getCompanyCustomerDetail(customerId) {
      let companyId = this.getLoggedInUserData().companyId
      let requestData={companyId:companyId, customerId : customerId};
      return this.callApi(requestData,"company/customerDetail");    

    }

    public getCompanyRatings() {
      let companyId = this.getLoggedInUserData().companyId
      let requestData={companyId:companyId};
      return this.callApi(requestData,"rating/companyRatings/");     
    }

    public filterCompanyRatings(days, takenBy) {
      let companyId = this.getLoggedInUserData().companyId
      let requestData={companyId:companyId,days:days, ratingTakenBy:takenBy};
      return this.callApi(requestData,"rating/filterRatings/");
    }

    timeDifference : any = function(previou)
    {

      var current = +new Date();

      var previous=+new Date(previou+'Z');

      var msPerMinute = 60 * 1000;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;

      var elapsed = current - previous;

      if (elapsed < msPerMinute) {
        var inSec=(Math.round(elapsed/1000).toString().indexOf("-")>-1)?1:Math.round(elapsed/1000);
        return inSec + ' sec ago';   
      }

      else if (elapsed < msPerHour) {
        return Math.round(elapsed/msPerMinute) + ' min ago';   
      }

      else if (elapsed < msPerDay ) {
        return Math.round(elapsed/msPerHour ) + ' hours ago';   
      }

      else if (elapsed < msPerMonth) {
        return  Math.round(elapsed/msPerDay) + ' days ago';   
      }

      else if (elapsed < msPerYear) {
        return Math.round(elapsed/msPerMonth) + ' months ago';   
      }

      else {
        return  Math.round(elapsed/msPerYear ) + ' years ago';   
      }
    };


    showPopup(title, text) {
      let alert = this.alertCtrl.create({
        title: title,
        subTitle: text,
        buttons: [
        {
          text: 'OK',
          handler: data => {

          }
        }
        ]
      });
      alert.present();
    }


    showLoading() {
      this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        //dismissOnPageChange: true
      });
      this.loading.present();
    }

    dismisshowoading() {
      setTimeout(() => {     
        this.loading.dismiss().catch(() => {
        }).then(() => {
        });
      },100);   
    }


    public saveRatingFactors(data) {

      return this.callApi(data,'company/set_factors/');
     

    }

    public createRating(data) {
       return this.callApi(data,'rating/create/');
    }


    public getCustomersComments() {

      let companyId = this.getLoggedInUserData().companyId;
      let requestData={companyId:companyId};
      return this.callApi(requestData,'rating/customersComment/');     

    }


    public isUserLoggedIn(){

      if(localStorage.getItem('current-user') && localStorage.getItem('current-user')!=null){
        return true;
      }else{
        return false;
      }
    }

    public setLoggedInUserData(data){

      localStorage.setItem('current-user',JSON.stringify(data));

    }

    public getLoggedInUserData(){

      if(this.isUserLoggedIn){
        return JSON.parse(localStorage.getItem('current-user'));
      }else{
        return null;
      }      

    }


    public sendMailToSupport(data) {
       return this.callApi(data,'company/support/');    
     }

    public listenConnection(): boolean {

      this.network.onDisconnect()
      .subscribe(() => {
        this.showPopup(this.sharedClass.messages.NetworkNotFoundTitle,this.sharedClass.messages.NetworkNotFoundMessage);
      });

      if(this.network.type=="none"){
        this.showPopup(this.sharedClass.messages.NetworkNotFoundTitle,this.sharedClass.messages.NetworkNotFoundMessage);
        return false;
      }
      return true;
    }

    public getDeviceInfo(){
      console.log('Device UUID is: ' + this.device.uuid);
      return this.device.uuid;
    }

    public backButtonAction(navCtrl): void {

      this.platform.ready().then(() => { 
        //back button handle
        //Registration of push in Android and Windows Phone
        var lastTimeBackPress=0;
        var timePeriodToExit=2000;

        this.platform.registerBackButtonAction(() => {

          let view = navCtrl.getActive();
          if(view.component.name!="SettingsPage"){

            if(new Date().getTime() - lastTimeBackPress < timePeriodToExit){
              this.platform.exitApp(); 
              //Exit from app
            }else{
              let toast = this.toastCtrl.create({
                message: 'Press back again to exit App?',
                duration: 3000,
                position: 'bottom'
              });
              toast.present();     
              lastTimeBackPress=new Date().getTime();
            }
          }

          // get current active page
         /*let view = navCtrl.getActive();
         if(view.component.name=="LoginComponent"){
              //Double check to exit app                  
              if(new Date().getTime() - lastTimeBackPress < timePeriodToExit){
                this.platform.exitApp(); 
                 //Exit from app
               }else{
                 let toast = this.toastCtrl.create({
                   message: 'Press back again to exit App?',
                   duration: 3000,
                   position: 'bottom'
                 });
                 toast.present();     
                 lastTimeBackPress=new Date().getTime();
               }
             }else{

               alert("else")
               if (navCtrl.canGoBack())
                 navCtrl.pop().then(() => {}, () => {}); 
                // If called very fast in a row, pop will reject because no pages

              }
              */
            }, 500);


      });

    }

    public updateSubcription(data) {

      return Observable.create(observer => {

        this.http.post(this.baseUrl+'company/updateSubscription/',data,{headers:this.headers})
        .map(response => response.json())
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        }, error => {
          console.log(error);// Error getting the data
          observer.next(false);
          observer.complete();
        });;
      });

    }


    public checkPricePlanAndUpdateDb(){

      this.iap
      .restorePurchases()
      .then((products) => {
        if(products.length>0){
          for (let product of products) {
            if (product.productId === this.sharedClass.pricing.plan2) {
              this.updateSubcription({companyId:this.getLoggedInUserData().companyId,subscribedPlan:this.sharedClass.pricing.plan2}).subscribe(success => {
                if (success && success.status=="success") {
                  alert(success.message);
                } else {         
                  this.showPopup("No Data", success.message);
                }
              });
            }
          }
        }
        //  [{ productId: 'com.yourapp.prod1', 'title': '...', description: '...', price: '...' }, ...]
      })
      .catch((err) => {
        console.log(err);
      });

    }

    changeLanguage(selectedItem){
      //console.log(selectedItem,"selectedItemselectedItem")
      this.translate.use(selectedItem);
      localStorage.setItem('selected-lang',selectedItem);

    }

    setAppRatePopupSetting(buttonIndex){
      if(buttonIndex==2){
        localStorage.setItem('app-rate-option',"later");
      }else if(buttonIndex==1 || buttonIndex==3){
        localStorage.setItem('app-rate-option',"never");
      }
      
    }

    public checkAppRatePopupSetting(){
      var appRateOption=localStorage.getItem('app-rate-option');
      var isShow=true;
      if(appRateOption && appRateOption!=""){
        if(appRateOption=="never" || appRateOption=="later"){
          isShow=false;
        }
      }
      return isShow;
    }

     public createSubcription(data) {

      return Observable.create(observer => {

        this.http.post(this.baseUrl+'razorpaypayments/createSubcription/',data,{headers:this.headers})
        .map(response => response.json())
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        }, error => {
          console.log(error);// Error getting the data
          observer.next(false);
          observer.complete();
        });;
      });

    }


    public getMyQRCode(data) {

      return Observable.create(observer => {

        this.http.post('https://customerfeedrate.com/qr-code-generator/ajax/process.php',data)
        .map(response => response.json())
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        }, error => {
          console.log(error);// Error getting the data
          observer.next(false);
          observer.complete();
        });;
      });

    }

    



  }


// WEBPACK FOOTER //
// ./src/services/common.service.ts